// mian list for pool

export default [
  {
    id: "LAVA-USDT",
    token_symbol: "LAVA-USDT",
    num_id: 0,
    item_icon: "lava.png",
    item_icon_b: "usdt.png",
    token_address: "0x3f15f2075aa11be4757aa522d133c0dbc7e878ce",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x8085086439699958a6E98aaafa45B4e488916B5C",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "LAVA-HT",
    token_symbol: "LAVA-HT",
    num_id: 1,
    item_icon: "lava.png",
    item_icon_b: "ht.png",
    token_address: "0xca65940b931272833307245c0d56ad86087e80a4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    // second_title:{
    //   en:'Promotional Pair',
    //   zh:'推广交易对'
    // },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "LAVA-ETH",
    token_symbol: "LAVA-ETH",
    num_id: 2,
    item_icon: "lava.png",
    item_icon_b: "eth.png",
    token_address: "0xf172f824e3865b612b8358f4bf39991a7f5406c5",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HBTC-USDT",
    token_symbol: "HBTC-USDT",
    num_id: 3,
    item_icon: "hbtc.png",
    item_icon_b: "usdt.png",
    token_address: "0x9961e56c26146f6fc52cf7a764c043eb97a511b0",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "ETH-USDT",
    token_symbol: "ETH-USDT",
    num_id: 4,
    item_icon: "eth.png",
    item_icon_b: "usdt.png",
    token_address: "0xa5e95efd5d9b69f61a3a41cd6d42b74ecb4de8e0",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HT-HUSD",
    token_symbol: "HT-HUSD",
    num_id: 5,
    item_icon: "ht.png",
    item_icon_b: "husd.png",
    token_address: "0xa24ec2896b0ea2271e7594453e6ed2c7fc8f828a",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    // second_title:{
    //   en:'Promotional Pair',
    //   zh:'推广交易对'
    // },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HT-USDT",
    token_symbol: "HT-USDT",
    num_id: 6,
    item_icon: "ht.png",
    item_icon_b: "usdt.png",
    token_address: "0x78cbb4b635caff4525b64bf64ed0b6dc350b101b",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    // second_title:{
    //   en:'Promotional Pair',
    //   zh:'推广交易对'
    // },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HUSD-USDT",
    token_symbol: "HUSD-USDT",
    num_id: 7,
    item_icon: "husd.png",
    item_icon_b: "usdt.png",
    token_address: "0x948358914ae19f54feecbb486e33cfae35242afe",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HPT-USDT",
    token_symbol: "HPT-USDT",
    num_id: 8,
    item_icon: "hpt.png",
    item_icon_b: "usdt.png",
    token_address: "0x67a0160a66b29378a13ae65e7975b6f9f0ad350f",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  

  {
    id: "HDOT-USDT",
    token_symbol: "HDOT-USDT",
    num_id: 10,
    item_icon: "dot.png",
    item_icon_b: "usdt.png",
    token_address: "0xf1e47ba481535d04a0f37139a6e68904ec911469",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },  

  {
    id: "SKM-USDT",
    token_symbol: "SKM-USDT",
    num_id: 29,
    item_icon: "skm.png",
    item_icon_b: "usdt.png",
    token_address: "0x713ffbb296ecbba8c26fef8607b39865c85d35b7",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "JT-USDT",
    token_symbol: "JT-USDT",
    num_id: 30,
    item_icon: "jt.png",
    item_icon_b: "usdt.png",
    token_address: "0x9283cc44a45d689e29f06215365dadcaf31f68c3",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },


  {
    id: "MX-HUSD",
    token_symbol: "MX-HUSD",
    num_id: 37,
    item_icon: "mx.png",
    item_icon_b: "husd.png",
    token_address: "0xea5922cb30e399b64b0bd55777280f5b2d928c6b",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },


  {
    id: "HBC-HUSD",
    token_symbol: "HBC-HUSD",
    num_id: 40,
    item_icon: "hbc.png",
    item_icon_b: "husd.png",
    token_address: "0xb67ef96951bd9cb7154d3a24a87f981f93e4687c",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "NULS-USDT",
    token_symbol: "NULS-USDT",
    num_id: 42,
    item_icon: "nuls.png",
    item_icon_b: "usdt.png",
    token_address: "0x24eb0ffb08f124d668b05101c3dfafda8502c752",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "VIBK-NULS",
    token_symbol: "VIBK-NULS",
    num_id: 43,
    item_icon: "vibk.png",
    item_icon_b: "nuls.png",
    token_address: "0xe99832350ac4d3401cd49ceef8765d71a627288f",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "DATT-USDT",
    token_symbol: "DATT-USDT",
    num_id: 45,
    item_icon: "datt.png",
    item_icon_b: "usdt.png",
    token_address: "0xF121c6BA2852679426E2dcF56eeB7F0A30b05a05",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "DATT-NULS",
    token_symbol: "DATT-NULS",
    num_id: 46,
    item_icon: "datt.png",
    item_icon_b: "nuls.png",
    token_address: "0xF0d134aaD095173Eea6c48EB1Dbb49C8341Ab9D9",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "ARCH-USDT",
    token_symbol: "ARCH-USDT",
    num_id: 47,
    item_icon: "arch.png",
    item_icon_b: "usdt.png",
    token_address: "0xeec243468cc46381bb1ab38214ec7131f6121e50",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "NYC-USDT",
    token_symbol: "NYC-USDT",
    num_id: 48,
    item_icon: "nyc.png",
    item_icon_b: "usdt.png",
    token_address: "0x07753f40f8f22c4519886274356690392de45623",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SHAREV2-USDT",
    token_symbol: "SHAREV2-USDT",
    num_id: 49,
    item_icon: "sharev2.png",
    item_icon_b: "usdt.png",
    token_address: "0x59fb095f9b40cc56e663311f51cdd798a5d31d82",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SHIB-USDT",
    token_symbol: "SHIB-USDT",
    num_id: 50,
    item_icon: "shib.png",
    item_icon_b: "usdt.png",
    token_address: "0x347F0Ad1017a5C2CC8DF02CBE349932F29CEbb41",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  
  {
    id: "FILDA-USDT",
    token_symbol: "FILDA-USDT",
    num_id: 16,
    item_icon: "filda.png",
    item_icon_b: "usdt.png",
    token_address: "0x961d2b834b403a097247d8e557d26a6c72b1a99c",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },
  
  {
    id: "SLNV2-USDT",
    token_symbol: "SLNV2-USDT",
    num_id: 18,
    item_icon: "slnv2.png",
    item_icon_b: "usdt.png",
    token_address: "0xf86a24c6d644712c4b29bd7877578c4b566e236c",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SLNV2-LAVA",
    token_symbol: "SLNV2-LAVA",
    num_id: 19,
    item_icon: "slnv2.png",
    item_icon_b: "lava.png",
    token_address: "0x374dc6357b7ca07e604116a2ef4ae0f180d23c16",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HFI-USDT",
    token_symbol: "HFI-USDT",
    num_id: 20,
    item_icon: "hfi.png",
    item_icon_b: "usdt.png",
    token_address: "0x329d6c7cc779f455bdc4eb4854d725a8ee544338",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HFI-LAVA",
    token_symbol: "HFI-LAVA",
    num_id: 21,
    item_icon: "hfi.png",
    item_icon_b: "lava.png",
    token_address: "0x211711613b7d8a9e20f3575a5869ba479fa8c900",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "BXS-USDT",
    token_symbol: "BXS-USDT",
    num_id: 22,
    item_icon: "bxs.png",
    item_icon_b: "usdt.png",
    token_address: "0x23005339d2a5992efe992c6a85acf46b6af78998",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "BXS-LAVA",
    token_symbol: "BXS-LAVA",
    num_id: 23,
    item_icon: "bxs.png",
    item_icon_b: "lava.png",
    token_address: "0xe120955fbf5f983d9ffb61374e790a1d1b758a19",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SOVI-USDT",
    token_symbol: "SOVI-USDT",
    num_id: 24,
    item_icon: "sovi.png",
    item_icon_b: "usdt.png",
    token_address: "0xe1b52215cb509f6c18668d9a8284bdffacc89ee5",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SOVI-LAVA",
    token_symbol: "SOVI-LAVA",
    num_id: 25,
    item_icon: "sovi.png",
    item_icon_b: "lava.png",
    token_address: "0xebdb16ef272e7accb0d696a7f56c09445887430b",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "MDX-USDT",
    token_symbol: "MDX-USDT",
    num_id: 27,
    item_icon: "mdx.png",
    item_icon_b: "usdt.png",
    token_address: "0x414aeea91bf9209a4f7b77999d0dc6d72ccca58a",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "BEE-USDT",
    token_symbol: "BEE-USDT",
    num_id: 28,
    item_icon: "bee.png",
    item_icon_b: "usdt.png",
    token_address: "0x54b204c9365c60115cd1beb6e8d03b9a4c0d89ed",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "BAGS-USDT",
    token_symbol: "BAGS-USDT",
    num_id: 31,
    item_icon: "bags.png",
    item_icon_b: "usdt.png",
    token_address: "0x2f09eb77f86a4b1daab8e552db12008fa3b29e4e",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "REC-USDT",
    token_symbol: "REC-USDT",
    num_id: 35,
    item_icon: "rec.png",
    item_icon_b: "usdt.png",
    token_address: "0x38605725707fdd2507d906675305cb06218e323b",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },


  {
    id: "GOF-USDT",
    token_symbol: "GOF-USDT",
    num_id: 33,
    item_icon: "gof.png",
    item_icon_b: "usdt.png",
    token_address: "0x32f856a800c7cfb193de07ccb8bfbf87404c2218",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "GENE-USDT",
    token_symbol: "GENE-USDT",
    num_id: 34,
    item_icon: "gene.png",
    item_icon_b: "usdt.png",
    token_address: "0x3ca4b39bf5bb739b2dbedaaa3e333701de86d942",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HOO-HUSD",
    token_symbol: "HOO-HUSD",
    num_id: 38,
    item_icon: "hoo.png",
    item_icon_b: "husd.png",
    token_address: "0xd38F68e314171ca0c28cB4F7803E5d3668b99242",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "LHB-HUSD",
    token_symbol: "LHB-HUSD",
    num_id: 39,
    item_icon: "lhb.png",
    item_icon_b: "husd.png",
    token_address: "0x2f05c5a6663bd20c9db29d3b186a0018b17640a5",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HLTC-USDT",
    token_symbol: "HLTC-USDT",
    num_id: 9,
    item_icon: "litecoin-ltc-logo.png",
    item_icon_b: "usdt.png",
    token_address: "0xf084a1eea0eaca7f201d56afe9a7475a764fe4c4",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "HFIL-USDT",
    token_symbol: "HFIL-USDT",
    num_id: 11,
    item_icon: "filecoin-fil-logo.png",
    item_icon_b: "usdt.png",
    token_address: "0xb44ff0a3a789c5a4e6b6f8eac58227b24a6b4448",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "UNI-USDT",
    token_symbol: "UNI-USDT",
    num_id: 12,
    item_icon: "uni.png",
    item_icon_b: "usdt.png",
    token_address: "0x7d19e7419a95f6fd40de87655834509f58f047d2",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "AAVE-USDT",
    token_symbol: "AAVE-USDT",
    num_id: 13,
    item_icon: "aave.png",
    item_icon_b: "usdt.png",
    token_address: "0x19ca99629dd097bd6443e7f37c3b6f029ee713e2",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SNX-USDT",
    token_symbol: "SNX-USDT",
    num_id: 14,
    item_icon: "snx.png",
    item_icon_b: "usdt.png",
    token_address: "0xc60c7e0c6b00e164d7954200d40895968f0aca30",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "FILDA-LAVA",
    token_symbol: "FILDA-LAVA",
    num_id: 15,
    item_icon: "filda.png",
    item_icon_b: "lava.png",
    token_address: "0xa45f787143ed49ef8d71a06db81af114037c7f84",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  

  {
    id: "LINK-USDT",
    token_symbol: "LINK-USDT",
    num_id: 17,
    item_icon: "link.png",
    item_icon_b: "usdt.png",
    token_address: "0x2b09f0021daf2c002ea0ddfdcad8c2fee0f6f0c7",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "YFI-USDT",
    token_symbol: "YFI-USDT",
    num_id: 26,
    item_icon: "yfi.png",
    item_icon_b: "usdt.png",
    token_address: "0xd430eca12bd360ae96f16a1e53df634ea925aebc",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "TPT-USDT",
    token_symbol: "TPT-USDT",
    num_id: 32,
    item_icon: "tpt.png",
    item_icon_b: "usdt.png",
    token_address: "0xd22c8c446c5cb70ff33534fa47d274e1026d0a8a",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },


  {
    id: "DEP-HUSD",
    token_symbol: "DEP-HUSD",
    num_id: 36,
    item_icon: "dep.png",
    item_icon_b: "husd.png",
    token_address: "0x9fadd57fe37f80e0c6a640d6f1bf5505d6f83d64",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "BAC-USDT",
    token_symbol: "BAC-USDT",
    num_id: 41,
    item_icon: "bac.png",
    item_icon_b: "usdt.png",
    token_address: "0xA8F3F9BB5bF09ccaF3FF8e2767A6e46fCA8Cd389",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

  {
    id: "SHARE-USDT",
    token_symbol: "SHARE-USDT",
    num_id: 44,
    item_icon: "share.png",
    item_icon_b: "usdt.png",
    token_address: "0xA83f4570556438E38979E868702B53643888a79f",
    //token_decimals: 18,
    token_earn_symbol: "LAVA",
    // 合约地址
    reward_address: "0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e",
    apy: "-",
    start_time: {
      en: "-",
      zh: "-"
    },
    des_earn_per_day: "",
    price_on_usd: 1,
    multiple: 0,
    daily_supply: 0,
  },

];